import { render, staticRenderFns } from "./ResourceCreateComponent.vue?vue&type=template&id=1f4474b9&"
import script from "./ResourceCreateComponent.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports